"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkVisibility = void 0;
// 兼容 浏览器 visibilitychange 事件

var o = {};
var checkVisibility = function checkVisibility() {
  if (!!o.hidden) return o;
  o.hidden = 'hidden';
  o.visibilityChange = 'visibilitychange';
  return o;
};
exports.checkVisibility = checkVisibility;